import { Flex } from 'app/components/design-system-components'
import { FilterDropdown } from 'app/components/design-system-components/list-filters/FilterDropdown'
import { theme } from 'app/match/applicationReportPDF/assets/theme'
import {
  buildRenderedFilterConfig,
  filtersIds,
} from 'app/pages/teams/rental-references/components/SearchAndFilter/filters.config'

const defaultTriggerProps = {
  mr: theme.space[3] + 'px',
  mb: theme.space[3] + 'px',
}

export const RRTableFilters = ({
  filters,
  updateFilter,
  teamId,
  managers,
  pods,
  statusOptions,
  sortOptions,
  includePodsFilter,
  isPodsDisabled = false,
  ...containerProps
}: any) => {
  const {
    [filtersIds.manager]: managerFilterConfig,
    [filtersIds.pods]: podsFilterConfig,
    [filtersIds.status]: statusFilterConfig,
    [filtersIds.sort]: sortFilterConfig,
  } = buildRenderedFilterConfig(filters, updateFilter)

  return (
    <Flex flexWrap="wrap" alignItems="center" {...containerProps}>
      <FilterDropdown
        filterConfig={managerFilterConfig}
        filterBodyProps={{ managers }}
        triggerCmpProps={defaultTriggerProps}
        requireConfirmationModal={undefined}
        confirmationModalText={undefined}
        confirmAction={undefined}
      />{' '}
      <FilterDropdown
        filterConfig={sortFilterConfig}
        filterBodyProps={{ sortOptions }}
        triggerCmpProps={defaultTriggerProps}
        requireConfirmationModal={undefined}
        confirmationModalText={undefined}
        confirmAction={undefined}
      />
      {includePodsFilter && (
        <FilterDropdown
          filterConfig={podsFilterConfig}
          filterBodyProps={{ pods, disabled: isPodsDisabled }}
          triggerCmpProps={defaultTriggerProps}
          requireConfirmationModal={undefined}
          confirmationModalText={undefined}
          confirmAction={undefined}
        />
      )}
      <FilterDropdown
        filterConfig={statusFilterConfig}
        filterBodyProps={{ statusOptions }}
        triggerCmpProps={defaultTriggerProps}
        requireConfirmationModal={undefined}
        confirmationModalText={undefined}
        confirmAction={undefined}
      />
    </Flex>
  )
}
